import React, {Component} from "react";
import * as styled from './shopDetail.styled';
import {
    AddToCartButton,
    CloseButton, ContinueShoppingButton,
    ProductDataContainer,
    ProductDataDescription,
    ProductDataTitle,
    ShopDetailContainer
} from "./shopDetail.styled";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faXmark} from "@fortawesome/pro-solid-svg-icons";
import * as cartController from '../../controllers/cart';
import {faLoader} from "@fortawesome/pro-duotone-svg-icons";
import $ from 'jquery';

class ShopDetail extends Component {
    constructor() {
        super();
        this.container = React.createRef();
        this.state = {
            productData: null,
            options: {},
            unitPrice: 0,
            currency: null,
            units: 1,
            selectedVariation: null,
            qty: 1,
            addingToCart: false,
            addedToCart: false
        };
    }

    componentDidCatch(error, errorInfo) {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!prevProps.productData && this.props.productData || prevProps.productData?.product.id !== this.props.productData?.product?.id) {
            this.setState((state) => {
                return {
                    ...state,
                    productData: this.props.productData
                }
            })
        }
    }

    reset() {
        return new Promise((resolve) => {
            this.setState((state) => {
                return {
                    productData: null,
                    options: {},
                    unitPrice: 0,
                    currency: null,
                    units: 1,
                    selectedVariation: null,
                    qty: 1,
                    addingToCart: false,
                    addedToCart: false
                };
            }, resolve);
        });

    }

    open(productData) {
        this.reset().then(() => {
            this.setState((state) => {
                return {
                    ...state,
                    productData,
                    options: this.getOptions(productData)
                };
            }, () => {
                this.setPrice();
                $(this.container.current)
                    .animate(
                        {opacity: 1},
                        500);
            });
        });
    }

    getOptions(productData) {
        let options = {};
        for (let option of productData.options) {
            options[option.id] = -1;
        }
        return options;
    }

    setOption(optionId, optionValueId) {
        this.setState((state) => {
            let options = state.options;
            options[optionId] = optionValueId;
            console.log('options', options);
            return {
                ...state,
                options
            };
        }, () => {
            this.setPrice();
        });
    }

    setPrice() {
        let unitPrice = 0;
        let currency = null;
        let selectedVariation = null;
        let allOptionsFilled = true;
        for (let option of Object.keys(this.state.options)) {
            if (this.state.options[option] === -1) {
                allOptionsFilled = false;
                break;
            }
        }
        if (allOptionsFilled) {
            for (let variation of this.state.productData.product.item_data.variations) {
                if (Object.keys(this.state.options).every((optionKey) => {
                    return variation.item_variation_data.item_option_values.some((variationOptionValue) => {
                        return (
                            variationOptionValue.item_option_id === optionKey
                            && variationOptionValue.item_option_value_id === this.state.options[optionKey]
                        );
                    });
                })) {
                    if (variation.item_variation_data.price_money) {
                        selectedVariation = variation;
                        unitPrice = variation.item_variation_data.price_money.amount;
                        currency = variation.item_variation_data.price_money.currency;
                    }
                    break;
                }
            }
        }

        this.setState((state) => {
            return {
                ...state,
                unitPrice,
                currency,
                selectedVariation
            };
        });
    }

    closeRequest() {
        $(this.container.current)
            .animate(
                {opacity: 0},
                500,
                () => {
                    this.close();
                });

    }

    close() {
        this.setState((state) => {
            return {
                ...state,
                productData: null
            }
        });
    }

    addToCart() {
        this.setAddingToCart(true).then(() => {
            cartController.addToCart({
                qty: this.state.qty,
                variation_id: this.state.selectedVariation.id
            }).then(() => {
                this.setAddedToCart();
                this.props.onCartChanged();
            });
        });
    }

    goToCart() {
        this.closeRequest();
        this.props.onCartOpenRequest();
    }

    setAddingToCart(addingToCart) {
        return new Promise((resolve) => {
            this.setState((state) => {
                return {...state, addingToCart};
            }, resolve);
        });
    }

    setAddedToCart() {
        this.setState((state) => {
            return {...state, addingToCart: false, addedToCart: true};
        });
    }

    changeQty(qty) {
        qty = parseInt(qty);
        if (isNaN(qty) || qty <= 0) qty = 1;
        this.setState((state) => {return {...state, qty}});
    }

    render() {
        if (!this.state.productData) return null;
        return (
            <styled.ShopDetailContainer ref={this.container}>
                <styled.CloseButton onClick={this.closeRequest.bind(this)}>
                    <FontAwesomeIcon icon={faXmark} />
                </styled.CloseButton>
                <styled.title>
                    {this.state.productData.product.item_data.name}
                </styled.title>
                <styled.ProductDataContainer>
                    <div style={{marginRight: '10px'}}>
                        <img
                            src={this.state.productData.images[0].image_data.url}
                            style={{width: '100%'}}
                        />
                    </div>
                    <div style={{marginLeft: '10px'}}>

                        <styled.ProductDataDescription>
                            {this.state.productData.product.item_data.description_plaintext}
                        </styled.ProductDataDescription>
                        {
                            this.state.productData.options.map((option, index) => {
                                return (
                                    <div key={option.id} style={{margin: '1vw 0'}}>
                                        <label style={{display: 'block'}}>{option.item_option_data.name}</label>
                                        <select id={option.id} style={{padding: '0.5em'}} value={this.state.options[option.id]} onChange={(e) => {this.setOption(option.id, e.currentTarget.value)}}>
                                            <option value={-1}>
                                                Select {option.item_option_data.name}
                                            </option>
                                            {
                                                option.item_option_data.values.map((optionValue, index) => {
                                                    return (
                                                        <option key={index} value={optionValue.id}>
                                                            {optionValue.item_option_value_data.name}
                                                        </option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                );
                            })
                        }
                        <div>
                            <label style={{display: 'block'}}>Quantity</label>
                            <input
                                type={"number"}
                                style={{
                                    padding: '0.5em',
                                    width: '3em',
                                    textAlign: 'right'
                                }}
                                onChange={(e) => {this.changeQty(e.currentTarget.value)}} value={this.state.qty}
                            />
                        </div>
                        <div style={{display: 'flex', marginTop: '2em', alignItems: 'center'}}>
                            <div>
                                {
                                    !this.state.addedToCart ?
                                        <styled.AddToCartButton
                                            onClick={this.addToCart.bind(this)}
                                            disabled={this.state.addingToCart || this.state.selectedVariation === null || isNaN(parseInt(this.state.qty))}
                                        >
                                            {
                                                this.state.addingToCart ?
                                                    <FontAwesomeIcon className={'addingToCartIcon'} icon={faLoader} spin style={{"--fa-primary-color": "#ffffff", "--fa-secondary-color": "#ffffff",}} />
                                                    : null
                                            }
                                            Add to cart
                                        </styled.AddToCartButton>
                                        :
                                        <styled.GoToCartButton
                                            onClick={this.goToCart.bind(this)}
                                        >
                                            <FontAwesomeIcon className={'addedToCartIcon'} icon={faCheck} style={{color: "#ffffff",}} />
                                            Go to cart
                                        </styled.GoToCartButton>
                                }

                            </div>
                            <div style={{paddingLeft: '2em', fontWeight: 'bold'}}>
                                {
                                    this.state.unitPrice > 0 ?
                                        <div style={{textAlign: 'right'}}>
                                            {(this.state.unitPrice / 100).toFixed(2)} {this.state.currency}
                                            <br/>
                                            <span style={{fontSize: '0.8em', color: 'gray', fontStyle: 'italic'}}>each</span>
                                        </div>
                                        : null
                                }
                            </div>
                        </div>
                        {
                            this.state.addedToCart ?
                                <div>
                                    <styled.ContinueShoppingButton onClick={this.closeRequest.bind(this)}>
                                        Continue shopping
                                    </styled.ContinueShoppingButton>
                                </div>
                                :
                                null

                        }

                    </div>
                </styled.ProductDataContainer>
            </styled.ShopDetailContainer>
        );
    }
}

export default ShopDetail;
